import * as BookedTripActions from '../actions/booked-trip.actions';
import * as BookedTripState from '../states/booked-trip.state';
import { BookedTrip, PassengersSegmentedCount, Flight } from '@ibe/models';
import * as _ from 'lodash';

export class State extends BookedTripState.State { }

const initialState: BookedTripState.State = BookedTripState.initialState;

/**
 *
 * @export
 * @param {*} [state=initialState]
 * @param {BookedTripActions.Actions} action
 * @returns {BookedTripState.State}
 */
export function reducer(state = initialState, action: BookedTripActions.Actions): BookedTripState.State {

	switch (action.type) {
		case BookedTripActions.ActionTypes.LOADING:
			state = Object.assign({}, state, { loading: true, bookedTrip: null });
			return state;
		case BookedTripActions.ActionTypes.PUT_PREORDER_ELEGIBLE:
			state = Object.assign({}, state, { preOrderEligible: action.payload});
			return state;
		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIP:
			state = Object.assign({}, state, { loading: false, bookedTrip: action.payload });
			return state;
		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIPPASSENGER:

			const passengers: PassengersSegmentedCount = action.payload;

			const flights = state.bookedTrip.flights.map(flight => {
				const neu_flight = new Flight(
					flight.departure,
					flight.departure,
					flight.number
				);
				Object.assign(neu_flight, flight);
				return neu_flight;
			});

			const bookedTrip = new BookedTrip(flights, state.bookedTrip.pnr, state.bookedTrip.booking_type, state.bookedTrip.status, passengers);

			if (passengers.adults && passengers.adults > 0) {
				for (let i = 0; i < passengers.adults; i++) {
					bookedTrip.addPassenger('adult');
				}
			}

			if (passengers.youngAdults && passengers.youngAdults > 0) {
				for (let i = 0; i < passengers.youngAdults; i++) {
					bookedTrip.addPassenger('youngAdult');
				}
			}

			if (passengers.children && passengers.children > 0) {
				for (let i = 0; i < passengers.children; i++) {
					bookedTrip.addPassenger('child');
				}
			}

			if (passengers.infants && passengers.infants > 0) {
				for (let i = 0; i < passengers.infants; i++) {
					bookedTrip.addPassenger('infant');
				}
			}

			state = Object.assign({}, state, { loading: false, bookedTrip });
			return state;
		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIP_DISCOUNT:
			state = Object.assign({}, state, { loading: false, bookedTrip: Object.assign(new BookedTrip(null, null, null), state.bookedTrip, { discounts: action.payload }) });
			return state;
		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIP_PROMO_VOUCHERS:
			state = Object.assign({}, state, { loading: false, promo_vouchers: Object.assign([], action.payload) });
			return state;
		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIP_INSURANCE:
			state = Object.assign({}, state, { loading: false, recoverInsurance: Object.assign([], action.payload) });
			return state;
		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIP_EXTRAS:
			if (state.extras) {
				const oldState = [];
				oldState.push(Object.assign({}, action.payload));
				state.extras.forEach(item => {
					if (item.type != action.payload.type) {
						oldState.push(item);
					}
				});
				state = Object.assign({}, state, { loading: false, extras: oldState });
			} else
				state = Object.assign({}, state, { loading: false, extras: [action.payload] });
			return state;
		case BookedTripActions.ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS:
			const tmp = [];
			if (state.extras) {
				state.extras.forEach(item => {
					if (item.type !== action.payload)
						tmp.push(item);
				});
			}
			state = Object.assign({}, state, { loading: false, extras: tmp });
			return state;

		case BookedTripActions.ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS_WITH_OPTIONS:
			let temp = [];
			if (state.extras) {
				const extras = _.cloneDeep(state.extras);
				extras.forEach(item => {
					if (item.stopoverCity === action.payload.stopoverCity) {
						if (item.type === action.payload.type) {
							const itemIdx = item.data.findIndex(x => x.id === action.payload.ancillary.data.id);
							if (itemIdx !== -1) {
								item.data.splice(itemIdx, 1);
								temp.push(item);
							}

					}}
				});	
				if (temp[0].data.length === 0) {
					temp = [];
					state.extras.forEach(item => {
						if (item.stopoverCity !== action.payload.stopoverCity)
							if (item.type !== action.payload.type) {
								temp.push(item);
							}
					});
				}
		}
			state = Object.assign({}, state, { loading: false, extras: temp });
			return state;

		case BookedTripActions.ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS_BY_CITY:
			const extra = [];
			if (state.extras) {
				state.extras.forEach(item => {
					if (item.stopoverCity !== action.payload.stopoverCity)
						extra.push(item);
				});
			}
		state = Object.assign({}, state, { loading: false, extras: extra });
		return state;

		case BookedTripActions.ActionTypes.REMOVE_BOOKEDTRIP_EXTRAS_BY_CITY_AND_TYPE:
		const extraByCityType = [];
		if (state.extras) {
			state.extras.forEach(item => {
				if (item.stopoverCity !== action.payload.stopoverCity || item.type !== action.payload.type)
					extraByCityType.push(item);
			});
		}
		state = Object.assign({}, state, { loading: false, extras: extraByCityType });
		return state;

		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIP_STOPOVER:
			state = Object.assign({}, state, { loading: false, stopover: Object.assign({}, action.payload) });
			return state;

		case BookedTripActions.ActionTypes.RESET:
			state = Object.assign({}, state, { loading: true, bookedTrip: null, weakflight_amt: null,  extras: null });
			return state;

		case BookedTripActions.ActionTypes.PUT_WEAKFLIGHT_AMT:
			state = Object.assign({}, state, { loading: false, weakflight_amt: action.payload });
			return state;
			
		case BookedTripActions.ActionTypes.PUT_BOOKEDTRIP_TIME_TO_THINK_DETAILS:
			state = Object.assign({}, state, { loading: false, bookedTrip: Object.assign(new BookedTrip(null, null, null), state.bookedTrip, { time_to_think: action.payload }) });
			return state;

		default:
			return state;
	}
}

export const getLoading = (state: BookedTripState.State) => state.loading;
export const getBookedTrip = (state: BookedTripState.State) => state.bookedTrip;
export const getBookedTripDiscounts = (state: BookedTripState.State) => { if (state.bookedTrip) return state.bookedTrip.discounts; };
export const getBookedTripPromoVouchers = (state: BookedTripState.State) => { if (state.promo_vouchers) return state.promo_vouchers; };
export const getContactDetails = (state: BookedTripState.State) => { if (state.bookedTrip) return state.bookedTrip.contact_details; };
export const getFlights = (state: BookedTripState.State) => { if (state.bookedTrip) return state.bookedTrip.flights; };
export const getPassengers = (state: BookedTripState.State) => { if (state.bookedTrip) return state.bookedTrip._passengers_info; };
export const getBookedTripRecoverInsurance = (state: BookedTripState.State) => { if (state.recoverInsurance) return state.recoverInsurance; };
export const getBookedTripExtras = (state: BookedTripState.State) => state.extras;
export const getBookedTripStopover = (state: BookedTripState.State) => state.stopover;
export const getBookedTripTTT = (state: BookedTripState.State) => state.bookedTrip ? state.bookedTrip.is_time_to_think : false;
export const getBookedTripTTTCompletionDetails = (state: BookedTripState.State) => state.bookedTrip ? state.bookedTrip.time_to_think : null; 
export const getPreOrderElegibility = (state: BookedTripState.State) => state.preOrderEligible;
export const getWeakFlightAmt = (state: BookedTripState.State) => state.weakflight_amt;